import { render } from "./ModalSuccessMessage.vue?vue&type=template&id=56ffee8e"
import script from "./ModalSuccessMessage.vue?vue&type=script&lang=js"
export * from "./ModalSuccessMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__